// 利用規約用の変換データ
export default {
  data: () => ({
    i18n_mode: process.env.VUE_APP_LANG_MODE,
    // i18n_mode: 'jp',
    i18n_message: {
      利用規約: {
        en: 'TERMS OF SERVICE',
      },
      '株式会社Iranoan（以下「当社」といいます。）が提供する本サイトにおいて提供するサービス（以下「本件サービス」といいます。）に関する条件及び当社とサービス利用者との権利義務関係について、以下のとおりサイト利用規約（その他の当社が契約の内容として別に定めるものを含みます。以下「本件規約」といいます。）として定めます。': {
        en: 'The terms and conditions of the Service (referred to as the "Service") provided by Iranoan Co., Ltd. (referred to as the "Company") on this site and the rights and obligations between the Company and the Service User are as follows. Stipulated in the Site Terms of Use (including any other agreements separately stipulated by the Company; referred to as the "Terms").',
      },
      '第1条（用語の定義）': {
        en: 'Article 1 (Definition of Terms)',
      },
      '本件規約における以下の各号の用語の意味は、当該各号に定めるとおりとします。': {
        en: 'The meanings of the terms in the following items in the Terms shall be as set forth in the respective items.',
      },
      '(1)「当社」とは、本サービスを提供する株式会社Iranoanのことをいいます。': {
        en: '(1) “Company” refers to Iranoan Co., Ltd., which provides this service.',
      },
      '(2)「本サイト」とは、当社が提供するサイト https://wanana.iranoan.com のことをいいます。': {
        en: '(2) “Site” means the website https://wanana.iranoan.com provided by the Company.',
      },
      '(3)「本規約」とは、サービス利用者が遵守すべき規定のことをいいます。': {
        en: '(3) "Terms" means the rules that Service User must comply with.',
      },
      '(4)「サービス利用契約」とは、本件サービスの利用に関する契約をいいます。': {
        en: '(4) "Service Agreement" means the agreement regarding the use of the Service.',
      },
      '(5)「サービス利用者」とは、当社とサービス利用契約を締結した者をいいます。': {
        en: '(5) "Service User" means a person who has entered into a service agreement with us.',
      },
      '(6)「アカウント」とは、サービス利用者が本件サービスに登録したサービス利用者に関する情報をいいます。': {
        en: '(6) "Account" means the information related to the Service User that the Service User has registered for the Service.',
      },
      '(7)「パスワード」とは、お客様自身で作成した英数字の組み合わせで構成される暗号をいいます。': {
        en: '(7) "Password" means a code consisting of a combination of alphanumeric characters created by the customer.',
      },
      '(8)「メールアドレス」とは、サービス利用者が本サービスにご登録いただいたメールアドレスをいいます。': {
        en: '(8) "E-mail address" means the e-mail address that the Service User has registered with this service.',
      },
      '(9)「ポイント」とは、本サイト内で使う事が出来る仮想通貨をいいます。': {
        en: '(9) “Points” means the virtual currency that can be used on this site.',
      },
      '(10)「商品」とは、本サイト内のゲームで獲得できるカードを示します。': {
        en: '(10) "Products" refers to cards that can be acquired in games on this site.',
      },
      '第2条（適用範囲）': {
        en: 'Article 2 (Scope of application)',
      },
      '1 サービス利用者は、本規約の定めに従って本サイトを使用しなければならず、本規約に同意しない限り本サイトを利用できません。': {
        en: '1. Service Users must use this site in accordance with the provisions of this agreement, and cannot use this site unless they agree to this agreement.',
      },
      '2 サービス利用者が、本サイトの登録画面において、本規約への同意手続を行った時点で、サービス利用者と当社との間で、本規約の諸規定に従った利用契約（以下「本利用契約」といいます。）が成立し、本規約の内容がサービス利用者と当社との間の契約内容となります。': {
        en: '2. At the time when the Service User performs the procedure for agreeing to this agreement on the registration screen of this site, the Service User and the Company enter into a usage contract in accordance with the provisions of this agreement (referred to as "contract") is established, and the content of this agreement becomes the content of the contract between the Service User and the Company.',
      },
      '第3条（本件サービスの内容等）': {
        en: 'Article 3 (Contents of the Service, etc.)',
      },
      '1 本件サービスの内容・利用手順は、ご利用ガイドに記載のとおりです。': {
        en: '1. The contents and usage procedures of this service are as described in the usage guide.',
      },
      '2 当社は、自らの判断により、随時本件サービスの内容を変更または提供を終了することができます。': {
        en: '2. The Company may, at its discretion, change the content of the Service or terminate the provision of the Service at any time.',
      },
      '3 サービス利用者は、当社による本件サービスの内容の変更もしくは提供の終了について異議を唱え、または損害賠償その他の請求を行うことはできません。': {
        en: '3. Service User may not raise objections to changes in the content of the Service or termination of the provision of the Service by the Company, or claim damages or other claims.',
      },
      '4 本件サービスの提供を終了する場合、当社の定める方法によって利用契約者に事前に通知するものとします。': {
        en: '4. When terminating the provision of the Service, the Company shall notify the user in advance by the method specified by the Company.',
      },
      '第4条（利用申込み）': {
        en: 'Article 4 (Application for use)',
      },
      '1 本件サービスの利用を希望する場合は、本サイトにアクセスし、本件規約に同意の上、本件サービスの利用申込み（以下、本条において「サービス利用申込み」といいます。）を行うものとします。': {
        en: '1. If you wish to use the Service, please access this Site, agree to the Terms, and apply for the use of the Service (referred to as the "Service Use Application" in this article).',
      },
      '2 サービス利用申込みに対し、当社が承諾することにより、当社とサービス利用申込みを行った方（以下、本条において「サービス利用申込者」といいます。）との間に、本件規約に基づくサービス利用契約が締結されます。': {
        en: '2. Upon acceptance of the Service use application by the Company, between the Company and the person who made the Service use application (referred to as the "Service Use Application" in this article), the Service User based on the Term A contract is concluded.',
      },
      '3 本サイトの利用希望者が未成年者等である場合、本サイトの利用に際し、事前に親権者等の法定代理人の同意を得るものとします。未成年者等が本規約に同意した場合は、法定代理人の同意を得たものとみなし、一切の責任は負いかねます。': {
        en: '3. If the person who wishes to use this site is a minor, etc., he/she shall obtain the prior consent of a legal representative such as a person with parental authority before using this site. If minors, etc. agree to these Terms, it is assumed that they have obtained the consent of their legal representative, and we do not take any responsibility.',
      },
      '4 当社は、サービス利用申込みを承諾しない場合があります。この場合において、当社は、その理由を開示する義務を負いません。': {
        en: '4. Our Company may not approve the Service usage application. In this case, we are not obliged to disclose the reason.',
      },
      '5 サービス利用申込者は、サービス利用申込みに際して不正確な情報または虚偽の情報を送信してはなりません。': {
        en: '5. Service use applicants must not send inaccurate or false information when applying for service use.',
      },
      '6 アカウント情報の誤りまたは変更の遅延その他の不備により、本件サービスの利用に支障が生じた場合であっても、当社は当該支障について責任を負いません。': {
        en: '6. Even if there is a problem with the use of the Service due to an error in the account information, a delay in changing it, or other deficiencies, the Company will not be held responsible for the problem.',
      },
      '7 本規約及びポイント利用規約は、当社が企画開発し、運営提供するhttps://wanana.iranoan.com における、有料サービスをご利用いただく上で、当社とサービス利用者間における取り決めを定めるものです。': {
        en: '7. This agreement and the point usage agreement establish the agreement between the Company and Service User when using paid services on https://wanana.iranoan.com, which is planned, developed, and operated by the Company.',
      },
      '8 有料サービスを利用する全てのユーザーは本規約の取り決めを遵守する事とします。': {
        en: '8. All users who use paid services shall comply with the terms of this agreement.',
      },
      '第5条（サービス利用者によるサービス利用契約の解約）': {
        en: 'Article 5 (Cancellation of Service Use Contract by Service User)',
      },
      'サービス利用者は、本件サービス上での解約手続きその他の当社が別途指定する解約手続きを行うことにより、いつでもサービス利用契約を解約することができます。': {
        en: 'The Service User may cancel the Service usage contract at any time by completing the cancellation procedure on this service or other cancellation procedures specified separately by the Company.',
      },
      '第6条（本件サービスの利用登録）': {
        en: 'Article 6 (Registration for use of this service)',
      },
      '1 サービス利用者が本件サービスを利用するために必要な端末、通信機器、ソフトウェア、インターネットへの接続に関する契約等の準備は、': {
        en: '1. Service Users must prepare terminals, communication equipment, software, contracts for connection to the Internet, etc. necessary for using this service at their own expense and responsibility.',
      },
      'サービス利用者が自己の費用と責任において準備しなければなりません。': {
        en: ' ',
      },
      '2 当社は、サービス利用者による本件サービスの利用環境について一切関与せず、また一切の責任を負いません。': {
        en: '2. The Company shall not be involved in, and shall not be held responsible for, the environment in which the Service is used by the Service User.',
      },
      '3 サービス利用者は、登録時にご自身のメールアドレスを登録することで、これを本件サービスにおけるメールアドレスとして利用出来ます。': {
        en: '3. By registering your e-mail address at the time of registration, the Service User can use it as the e-mail address for this service. In addition, it is not possible to change the e-mail address on the site, so if you register with an incorrect e-mail address or change your e-mail address, we will change it after confirming your identity. increase.',
      },
      'なお、サイト内でメールアドレスの変更はできかねますので誤ったメールアドレスで登録を': {
        en: ' ',
      },
      'した場合やメールアドレスの変更がある際は、本人確認をさせていただいた上で当社において変更を行わせていただきます。': {
        en: ' ',
      },
      '4 サービス利用者は、原則としてお１人様１アカウントとし、複数アカウントの所持を禁止します。': {
        en: '4. As a general rule, Service User shall have one account per person, and possession of multiple accounts is prohibited. In addition, if the Company discovers that a Service User has multiple accounts, the Company will delete the accounts owned by the Service User without prior notice. In this case, all points charged to the deleted account will be forfeited.',
      },
      'なお、当社は、サービス利用者の複数アカウントの所持が発覚した場合、事前の告知無く当該サービス利用者の所持するアカウントを削除します。': {
        en: ' ',
      },
      'この際、削除したアカウントに課金されているポイントは全て失効します。': {
        en: ' ',
      },
      '5 本サイトの運営が困難であると当社が判断した場合、当該要因が解消されるまで、当社はサービス利用者に対し、本サービスの利用を制限する事が出来るものとします。': {
        en: '5. If the Company determines that the operation of this site is difficult, the Company may restrict the use of this service by Service User until the relevant factors are resolved.',
      },
      '第7条（アカウントの管理）': {
        en: 'Article 7 (Account Management)',
      },
      '1 利用者は、利用に際して登録した情報（以下、「登録情報」といいます。メールアドレスやID': {
        en: '1. The User shall register and manage the information registered at the time of use (referred to as "registered information", including e-mail address, ID, password, etc.) under his/her responsibility. The user shall not let a third-party use this, or lend, transfer, change the name, sell, etc.',
      },
      '・パスワード等を含みます）について、自己の責任の下に登録、管理するものとします。利用者': {
        en: ' ',
      },
      'は、これを第三者に利用させ、または貸与、譲渡、名義変更、売買などをしてはならないものと': {
        en: ' ',
      },
      'します。': {
        en: ' ',
      },
      '2 当社は、登録情報によって本サービスの利用があった場合、利用登録をおこなった本人が利用': {
        en: '2. If the Service is used based on the registered information, the Company may treat it as if it was used by the person who registered for use, and shall not be held liable for any consequences arising from such use and any liability associated with such use.',
      },
      'したものと扱うことができ、当該利用によって生じた結果ならびにそれに伴う一切の責任につい': {
        en: ' ',
      },
      'ては、利用登録を行った本人に帰属するものとします。': {
        en: ' ',
      },
      '3 利用者は、登録情報の不正使用によって当社または第三者に損害が生じた場合、当社および第': {
        en: '3. If the Company or a third-party suffers damage due to the unauthorized use of registered information, the user shall compensate the Company and the third-party for the damage.',
      },
      '三者に対して、当該損害を賠償するものとします。': {
        en: ' ',
      },
      '4 登録情報の管理は、利用者が自己の責任の下で行うものとし、登録情報が不正確または虚偽で': {
        en: '4. The User shall manage the registered information under their responsibility, and the Company shall not be responsible for any disadvantages or damages suffered by the user due to inaccurate or false registered information.',
      },
      'あったために利用者が被った一切の不利益および損害に関して、当社は責任を負わないものとし': {
        en: ' ',
      },
      '5 登録情報が盗用されまたは第三者に利用されていることが判明した場合、利用者は直ちにその': {
        en: '5. If it turns out that the registered information has been stolen or used by a third-party, The User shall immediately notify the Company to that effect and follow the instructions from the Company.',
      },
      '旨を当社に通知するとともに、当社からの指示に従うものとします。': {
        en: ' ',
      },
      '第8条（サービス利用者の義務）': {
        en: 'Article 8 (Obligations of Service User)',
      },
      '1 サービス利用者は、当社が別途明示的に許可した場合を除き、本件サービスに関し、': {
        en: '1. Service User shall not engage in any of the following acts in relation to the Service, unless otherwise expressly permitted by the Company.',
      },
      '以下の各号の行為を行ってはなりません。': {
        en: ' ',
      },
      '(1) 法令に違反する行為': {
        en: '(1) Acts that violate laws and regulations.',
      },
      '(2) 本件規約に違反する行為': {
        en: '(2) Acts that violate the Terms.',
      },
      '(3) 当社または第三者に不当に不利益または損害を生じさせる行為': {
        en: '(3) Acts that unfairly cause disadvantage or damage to the Company or a third-party.',
      },
      '(4) 本件サービスの各機能の目的外利用': {
        en: '(4) Unintended use of each function of the Service.',
      },
      '(5) 本件サービスを通常利用する際に用いられる方法とは異なる方法（自動化、スクレイピング': {
        en: '(5) Use of the Service by a method (including automation and scraping) different from the method normally used when using the Service.',
      },
      'を含みます。）による本件サービスの利用': {
        en: ' ',
      },
      '(6) 当社または第三者の知的財産権侵害': {
        en: '(6) Infringement of intellectual property rights of the Company or a third-party.',
      },
      '(7) 当社または第三者に関するプライバシーもしくは肖像権の侵害': {
        en: '(7) Infringement of privacy or portrait rights of the Company or a third-party.',
      },
      '(8) 当社または第三者の秘密情報の漏洩': {
        en: '(8) Leakage of confidential information of the Company or a third-party.',
      },
      '(9) 本件サービス内で閲覧できる情報の第三者提供': {
        en: '(9) Third-party provision of information that can be viewed within the Service.',
      },
      '(10) 本人の同意を得ない第三者の個人情報の提供': {
        en: '(10) Provision of personal information of a third-party without the consent of the individual.',
      },
      '(11) 当社または第三者に対する誹謗中傷': {
        en: '(11) Slander against our Company or a third-party.',
      },
      '(12) 当社または第三者の名誉または信用の毀損': {
        en: '(12) Defamation of the reputation or credibility of the Company or a third-party.',
      },
      '(13) 当社または第三者へのなりすまし': {
        en: '(13) Impersonating the Company or a third-party.',
      },
      '(14) 第三者のアカウント情報の利用': {
        en: '(14) Use of third-party account information.',
      },
      '(15) 本件サービスの提供に用いられるシステムに記録された情報の改ざんまたは消去': {
        en: '(15) Falsification or deletion of information recorded in the system used to provide the Service.',
      },
      '(16) 有害なコンピュータプログラム等の送信、または当社もしくは第三者のリクエストに応じ': {
        en: '(16) Transmission of harmful computer programs, etc., or making it possible to transmit at the request of the Company or a third-party.',
      },
      て送信可能な状態におくこと: {
        en: ' ',
      },
      '(17) 他のサービス及び商品等並びに団体及び組織等の広告、宣伝または勧誘': {
        en: '(17) Advertisement, publicity, or solicitation of other services and products, as well as groups and organizations.',
      },
      '(18) 本件サービスの提供その他の業務の妨害': {
        en: '(18) Interference with the provision of the Service or other business.',
      },
      '(19) コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報の送信': {
        en: '(19) Transmission of information containing computer viruses or other harmful computer programs.',
      },
      '(20) 本件サービスの提供に用いられている電気通信設備（サーバーを含みますがこれに限りま': {
        en: '(20) Excessive load on telecommunication equipment (including but not limited to servers; referred to as "telecommunication equipment") used to provide the Service.',
      },
      'せん。以下、「電気通信設備」といいます。）に過度な負荷をかける行為': {
        en: ' ',
      },
      '(21) 本件サービスの提供に用いられるシステムに設定されたアクセス制御機能の解除または回': {
        en: '(21) Disabling or circumventing the access control function set in the system used to provide the Service or other unauthorized access.',
      },
      避その他の不正アクセス: {
        en: ' ',
      },
      '(22) 本件サービスに用いられるソフトウェアの複製、修正、転載、改変、変更、リバースエン': {
        en: '(22) Copying, modifying, reprinting, altering, altering, reverse engineering, disassembling, decompiling, translating, or analyzing the software used for the Service.',
      },
      'ジニアリング、逆アセンブル、逆コンパイル、翻訳または解析': {
        en: ' ',
      },
      '(23) 詐欺的な手段（いわゆるフィッシング及びこれに類する手段を含みます。）による当社ま': {
        en: '(23) Acquisition of information from the Company or third parties by fraudulent means (including so-called phishing and similar means).',
      },
      たは第三者からの情報の取得: {
        en: ' ',
      },
      '(24) 当社に対する過度に長時間の架電、同様の問い合わせの過度の繰り返し、または義務や理': {
        en: '(24) Calling the Company for an excessively long time, excessively repeating similar inquiries, or forcing the Company to respond without obligation or reason.',
      },
      由のない対応の強要: {
        en: ' ',
      },
      '(25) 機器の販売、情報の提供、ハイパーリンクの設定等により上記各号のいずれかに該当する': {
        en: '(25) Acts that promote any of the above acts by selling equipment, providing information, setting hyperlinks, etc.',
      },
      行為を助長する行為: {
        en: ' ',
      },
      '(26) 上記各号のいずれかに該当するおそれがある行為': {
        en: '(26) Acts that may fall under any of the above items.',
      },
      '(27) その他当社が不適当と判断した行為': {
        en: '(27) Other acts that the Company deems inappropriate.',
      },
      '2 アカウント情報に変更が生じた場合、サービス利用者は遅滞なく当該変更後の情報を登録しな': {
        en: '2. If there is any change in the account information, the Service User must register the changed information without delay.',
      },
      'ければなりません。': {
        en: ' ',
      },
      '第9条（個人情報の取扱い）': {
        en: 'Article 9 (Handling of personal information)',
      },
      'サービス利用者は、当社が個人情報保護ポリシーの定めに従ってサービス利用者の個人情報を取': {
        en: 'The Service User agrees that the Company will handle the personal information of the Service User in accordance with the provisions of the personal information protection policy.',
      },
      'り扱うことに同意します。': {
        en: ' ',
      },
      '第10条（サービス利用者にかかる情報の削除）': {
        en: 'Article 10 (Deletion of Information Concerning Service User)',
      },
      '1 当社は、サービス利用者とのサービス利用契約が解約された場合、当該サービス利用者にかか': {
        en: '1. If the contract with the Service User is terminated, the Company shall retain information on the Service User (including, but not limited to, account information, in-app currency, and information on paid services). ',
      },
      'る情報（アカウント情報、アプリ内通貨及び有償サービスにかかる情報を含みますが、これに限': {
        en: ' ',
      },
      'りません。）を削除します。': {
        en: ' ',
      },
      '2 当社は前項に基づき削除したサービス利用者にかかる情報の復元等は行いません。': {
        en: '2. The Company will not restore information related to Service User deleted based on paragraph 1.',
      },
      '第11条（サービスに関する権利）': {
        en: 'Article 11 (Rights regarding services)',
      },
      '当社より、本件サービスを通じてサービス利用者に提供されるコンテンツ及び情報等に関する知': {
        en: 'Intellectual property rights and other rights related to the content, information, etc. provided by the Company to Service User through the Service belong to the Company or third-parties that have granted rights to the Company.',
      },
      '的財産権その他の権利は、当社または当社に権利を許諾している第三者に帰属します。': {
        en: ' ',
      },
      '第12条（有料サービスについて）': {
        en: 'Article 12 (Paid Services)',
      },
      '1 サービス利用者は、当社所定の方法により、当社が本件サービス内又は当社の提供する': {
        en: '1. Service User may purchase points that can be used only within the Services provided by the Company at the amount indicated by the Company within the Service or other services provided by the Company, in accordance with the method prescribed by the Company. increase. In addition, the Company may set the purchase unit, payment method, usage period, and other purchase conditions for the purchase of points for the Service User, and the set purchase conditions and payable amount, etc. will be posted in the Service.',
      },
      他のサービスで提示している金額で当社の提供するサービス内でのみ使用可能なポイント: {
        en: ' ',
      },
      'を購入することができます。なお、当社は、サービス利用者に対して、ポイントの購入に': {
        en: ' ',
      },
      'ついて購入単位、決済方法、利用期間その他の購入条件を設けることがあり、設定した購': {
        en: ' ',
      },
      '入条件及び支払可能金額等は、本件サービス内に掲載します。': {
        en: ' ',
      },
      '2 ポイントの利用条件その他ポイントの利用に関わる条件については、本規約の他、本サ': {
        en: '2. Terms of use of points and other conditions related to the use of points shall comply with the terms of use of points posted on this site in addition to this agreement.',
      },
      'イト内に掲載するポイント利用規約の定めに従うものとします。': {
        en: ' ',
      },
      '3 サービス利用者は、有料サービス利用料(その他有料サービスを通じてサービス利用者': {
        en: '3. The Service User shall pay the paid service usage fee (including any other debts incurred by the Service User through the paid service) in accordance with the payment method and conditions separately determined by the Company. The Company will not refund any fees once paid, except in cases where the Company is legally responsible such as being negligent.',
      },
      'に債務が生じた場合はそれも含める)を、当社が別途定める支払い方法と条件に従い、支': {
        en: ' ',
      },
      '払うものとします。当社は、当社に過失があるなどの法的責任がある場合を除き、一度支': {
        en: ' ',
      },
      '払いを受けた当該料金について一切返金しないものとします。': {
        en: ' ',
      },
      '第13条（商品について）': {
        en: 'Article 13 (Products)',
      },
      '1 サービス利用者は、有料サービスを利用して獲得した商品の配送を受けることが出来ます。': {
        en: '1. The Service User can receive delivery of products acquired through paid services.',
      },
      '2 サービス利用者は、獲得した商品を、獲得時より24時間以内まで保有することが出来': {
        en: '2. The Service User can hold the acquired product for up to 24 hours from the time of acquisition (this period is referred to as the "retention period"), and if you wish to have it delivered, you can must follow the prescribed delivery procedures.',
      },
      '（以下、当該期間を「保有期間」といいます。）、配送を希望する場合には、本サイトから所': {
        en: ' ',
      },
      '定の配送手続を行わなければなりません。': {
        en: ' ',
      },
      '3 前項の保有期間を過ぎた場合、サービス利用者はそれらの商品の配送を受ける権利を失うもの': {
        en: '3. If the retention period of the preceding paragraph has passed, the Service User shall lose the right to receive delivery of those products. In addition, points will be automatically returned for products whose holding period has passed.',
      },
      'とします。なお、保有期間を過ぎた商品につきましては自動的にポイント返還するものとしま': {
        en: ' ',
      },
      '4 当社は、サービス利用者の獲得した商品について、配送することが当社の責めに帰すべき事由': {
        en: '4. If it becomes clear that it is impossible to deliver the product acquired by the Service User due to reasons attributable to the Company, the Company will notify the Service User by granting the points used for the Service to the Service User, the liability for damages will be exempted. In addition, the Company shall not be obligated to acquire and deliver the same product as the relevant product.',
      },
      'により不能であることが明らかとなった場合には、当社は、サービス利用者が当該商品を取得す': {
        en: ' ',
      },
      'るために使用したポイントをサービス利用者に対して付与することにより、その損害賠償責任を': {
        en: ' ',
      },
      '免れることとします。なお、当社は当該商品と同一の商品を取得し交付する義務を負わないもの': {
        en: ' ',
      },
      'とします。': {
        en: ' ',
      },
      '5 商品に関する配送料は全額当社負担といたします。なお、国外への配送については別途料金を': {
        en: '5. All shipping charges for the product shall be borne by the Company. Please note that a separate fee may be collected for overseas delivery.',
      },
      '徴収する場合がございます。': {
        en: ' ',
      },
      '6 配送方法は当社提携先のヤマト運輸株式会社又は当社指定業者を利用いたします。': {
        en: '6. We will use Yamato Transport Co., Ltd., our business partner, or a Company designated by us for the delivery method.',
      },
      '7 配送時期は、発送依頼を受けた日から原則3日〜7日で発送いたします。': {
        en: '7. In principle, we will ship within 3 days from the date of receiving the shipping request.',
      },
      '※発送前の状態確認で看過できない傷があった際には、発送までに上記以上のお時間を頂戴することがございます。(発送させて頂き次第、発送通知の上、追跡番号を反映いたします)': {
        en: '(*The tracking number will be sent to your registered email address.)',
      },
      '※発送件数が多い時や、他業務がある際は、上記期日を超える場合がございます。': {
        en: ' ',
      },
      '※16時半以降の発送通知に記載の追跡反映は翌夕方頃の反映になる場合がございます。': {
        en: ' ',
      },
      '8 商品発送中の破損などのトラブルが発生した場合、当社は一切の責任を負いかねます。': {
        en: '8. We are not responsible for any troubles such as damage during shipping.',
      },
      '9 当社は、当該商品の配送までにサービス利用者の規約違反行為等が認められた場合には、商品': {
        en: '9. The Company shall be able to suspend the delivery of the product if it is recognized that the Service User has violated the terms of service before the delivery of the product. In addition, we are not responsible for any damages caused by this.',
      },
      'の配送を停止することができるものとします。なお、これによる損害について当社は賠償する責': {
        en: ' ',
      },
      '任を負いません。': {
        en: ' ',
      },
      '10 当社がサービス利用者に対して商品を配送した後、受け取り拒否、宛先不明等で返送され、': {
        en: '10. After the Company has delivered the product to the Service User, if the product is returned due to refusal of receipt, unknown address, etc., and the Service User does not follow the procedure for resending, the Service User will lose the right to the product shall forfeit all. Even in this case, the Company shall not be liable for any compensation or compensation for damages, such as the obligation to return points.',
      },
      '当該サービス利用者が再送手続を行わなかった場合には、当該サービス利用者は、当該商品に関': {
        en: ' ',
      },
      'する権利の一切を失うものとします。なお、この場合であっても、当社はポイントの返還義務等': {
        en: ' ',
      },
      'の一切の補償、損害賠償義務を負いません。': {
        en: ' ',
      },
      '11.ログインガチャなどはその限りではございません。弊社判断で発送をさせて頂きますが、2週間以内には発送を行わせて頂きます。': {
        en: '11. Login Gacha is not limited to this. We will ship at our discretion, but we will ship within 2 weeks.',
      },
      '12.配送日等のお問い合わせにはご対応致しかねますこと、予めご容赦くださいませ。': {
        en: '12. Please accept our apologies for not being able to respond to inquiries regarding delivery dates, etc.',
      },
      '13.発送件数が多い時や、他業務がある際は、告知なく、上記期日を超える場合がございますこと、予めご容赦くださいませ。': {
        en: '13. Please note that the above deadline may be exceeded without notice when there are a large number of shipments or when there are other duties.',
      },
      '14.本システムは商品名と還元ポイントが結びついております。': {
        en: '14. In this system, product names and reward points are linked. In the unlikely event that the image does not match the product name, please forgive us in advance that the product name and return points will take precedence over the shipping of the product in the image or the return points.',
      },
      '万が一、画像が商品名と一致しない場合は、画像の商品の発送もしくは還元ポイントではなく、': {
        en: ' ',
      },
      'その商品名と還元ポイントを優先させていただきますこと予めご容赦ください。': {
        en: ' ',
      },
      '第14条（クレジットカード等による利用）': {
        en: 'Article 14 (Use by credit card, etc.)',
      },
      '1 本サイトにおいて、サービス利用者は、クレジットカードによる決済又は当社が提供す': {
        en: '1. On this site, Service User can purchase points by making payments with a credit card or by using the method stipulated within other services provided by the Company. However, the credit card used for payment must be in the name of the Service User and be valid at the time of payment.',
      },
      'る他のサービス内においては当該サービス内で定められた方法を利用することにより、ポ': {
        en: ' ',
      },
      'イントの購入を行うことができます。ただし、決済に利用するクレジットカードは、サー': {
        en: ' ',
      },
      'ビス利用者本人名義のものであり、かつ、決済時に有効なものに限られます。': {
        en: ' ',
      },
      '2 サービス利用者は、クレジットカード決済を利用する場合、当該サービス利用者本人名': {
        en: '2. When using credit card payment, the Service User shall provide information related to the credit card in the name of the Service User (credit card type, card number, expiration date, etc.,) collectively (referred to as "credit card information”) shall be registered by the method specified by the Company.',
      },
      '義のクレジットカードに関する情報（クレジットカードの種類、カード番号及び有効期限': {
        en: ' ',
      },
      '等をいうものとし、以下、総称して「クレジットカード情報」といいます。）を当社指定': {
        en: ' ',
      },
      'の方法により登録するものとします。': {
        en: ' ',
      },
      '3 クレジットカード情報の誤登録等によりサービス利用者に生じた損害について、当社は': {
        en: '3. The Company shall not be held responsible for any damages incurred by Service User due to incorrect registration of credit card information. In addition, if the Company suffers damages due to falsehood or fraud by the Service User regarding the use of the credit card, the Service User shall indemnify the Company for any damages suffered by the Company.',
      },
      '一切責任を負いません。また、クレジットカードの利用に関するサービス利用者の虚偽又': {
        en: ' ',
      },
      'は不正により当社が損害を被った場合、当該サービス利用者は当社に対して、当社の被っ': {
        en: ' ',
      },
      'た一切の損害を賠償するものとします。': {
        en: ' ',
      },
      '4 当社は、本サイトの利用のために発生した料金についてのクレジットカードによる決済': {
        en: '4. When paying by credit card for the charges incurred for using this site, the Company shall request approval from the credit card Company regarding the acceptance or rejection of payment for the credit card used by the Service User for payment by a predetermined method, and if approval is not obtained, the payment may not be made. In this case, even if the Service User suffers damage, the Company will not be held responsible for the damage.',
      },
      '時において、所定の方法によりサービス利用者が決済に利用するクレジットカードについ': {
        en: ' ',
      },
      'て、クレジットカード会社に支払い可否の承認を求めるものとし、その承認が得られない': {
        en: ' ',
      },
      '場合は、決済をしないものとすることができます。この場合、サービス利用者に損害が生': {
        en: ' ',
      },
      'じたときであっても、当社は当該損害について一切責任を負いません。': {
        en: ' ',
      },
      '5 サービス利用者のクレジットカードによる決済が終了した後であっても、クレジットカ': {
        en: '5. Even after the Service User\'s credit card payment has been completed, if the credit card Company notifies the Company of the refusal or suspension of the use of the credit card, or the use of the Service related to the use of the credit card. In the event that a person\'s falsehood or fraud is found, regardless of the reason, we shall be able to suspend all payments by the Service User.',
      },
      'ード会社から当社に対し、当該クレジットカードの利用につき拒絶もしくは停止の通知が': {
        en: ' ',
      },
      なされた場合またはクレジットカードの利用に関する当該サービス利用者の虚偽若しくは: {
        en: ' ',
      },
      '不正が判明した場合、当社はその理由のいかんを問わず、当該サービス利用者による全て': {
        en: ' ',
      },
      'の決済を中止できるものとします。': {
        en: ' ',
      },
      '6 サービス利用者は、当社の提供する他のサービス内で本サービスに利用することができ': {
        en: '6. Service User can purchase points that can be used for this service within other services provided by our Company.',
      },
      'るポイントを購入することができますが、その場合には、本サービスと同一のアカウント': {
        en: ' ',
      },
      'により購入をしなければならず、他のアカウントによりポイントを購入した場合には、本': {
        en: ' ',
      },
      'サービス内でポイントが反映されず、使用できないことを了承するものとします。なお、': {
        en: ' ',
      },
      'その場合には、当社は一切の返金等を行わず、一切の責任を負わないものとします。': {
        en: ' ',
      },
      '第15条（決済機関との関係等）': {
        en: 'Article 15 (Relationship with Settlement Institutions, etc.)',
      },
      '1 サービス利用者と本サービスのために当社が用いる課金決済会社又は決済代行会社との間で本': {
        en: '1. If a dispute arises between the Service User and the billing settlement Company or settlement agent Company used by the Company for this service over the fee for this service or other monetary obligations, the Service User and the Company shall be resolved between them, and the Company shall not be involved in it in any way and shall not bear any responsibility.',
      },
      'サービスの料金その他の金銭債務を巡って紛争が生じた場合、当該サービス利用者と当該会社と': {
        en: ' ',
      },
      'の間で解決するものとし、当社は、一切それに関与せず、一切の責任を負わないものとします。': {
        en: ' ',
      },
      '2 前項の紛争がサービス利用者の責めに帰すべき事由により生じたものであって、これにより当': {
        en: '2. If the dispute set forth in the preceding paragraph arises due to reasons attributable to the Service User and the Company suffers damage due to this, the Service User shall compensate the Company for all damages suffered by the Company.',
      },
      '社が損害を被った場合、当該サービス利用者は当社に対して当社の被った一切の損害を賠償する': {
        en: ' ',
      },
      'ものとします。': {
        en: ' ',
      },
      '第16条（本件サービスの提供の停止等）': {
        en: 'Article 16 (Suspension of Provision of the Service, etc.)',
      },
      '当社は、以下のいずれかの場合には、損害賠償その他の義務を負うことなく、一時的に本件サー': {
        en: 'In any of the following cases, the Company may temporarily suspend the provision of all or part of the Service without liability for damages or other obligations.',
      },
      'ビスの全部または一部の提供を停止できるものとします。': {
        en: ' ',
      },
      '(1) 本件サービスを提供するための設備の保守または点検等を行う場合': {
        en: '(1) When performing maintenance or inspection of facilities for providing the Service.',
      },
      '(2) 火災、停電等により本件サービスの提供に支障が生じた場合': {
        en: '(2) When the provision of the Service is hindered due to fire, power outage, etc.',
      },
      '(3) 地震、噴火、洪水、津波等の天災により本件サービスの提供に支障が生じた場合': {
        en: '(3) When the provision of the Service is hindered by a natural disaster such as an earthquake, eruption, flood, tsunami, etc.',
      },
      '(4) 戦争、動乱、暴動、騒乱、労働争議、感染症の蔓延、緊急事態宣言の発出等により本件サー': {
        en: '(4) When the provision of the Service is hindered due to war, riots, riots, riots, labor disputes, the spread of infectious diseases, the issuance of a state of emergency declaration, etc.',
      },
      ビスの提供に支障が生じた場合: {
        en: ' ',
      },
      '(5) 本件サービスの運用上または技術上の理由により、当社が本件サービスの提供を一時的に延': {
        en: '(5) When the Company deems it necessary to temporarily postpone or suspend the provision of the Service due to operational or technical reasons for the Service.',
      },
      期または中断する必要があると判断した場合: {
        en: ' ',
      },
      '第17条（利用制限等）': {
        en: 'Article 17 (Use Restrictions, etc.)',
      },
      '1 当社は、サービス利用者が以下の各号のいずれかに該当すると判断した場合には、サービス利': {
        en: '1. If the Company determines that the Service User falls under any of the following items, the Company may suspend the use of the Service or terminate the Service Use Agreement without prior notice to the Service User (referred to as "usage restriction measures" in this article) may be taken.',
      },
      '用者に事前に通知することなく、本件サービスの利用の停止、またはサービス利用契約の解約等': {
        en: ' ',
      },
      'の措置（以下、本条において「利用制限措置」といいます。）を講じることができるものとしま': {
        en: ' ',
      },
      'す。': {
        en: ' ',
      },
      '(1) サービス利用者のパスワードが漏洩する事により、第三者が本サービスを不正利用した場合': {
        en: '(1) If a third-party uses this service illegally due to the leakage of the Service User\'s password, or if a third-party illegally uses other services of our Company.',
      },
      '、当社の他のサービスを第三者が不正に利用した場合またはこれらの恐れのある場合。': {
        en: ' ',
      },
      '(2) サービス利用者の行為によって当社の事業に支障をきたすと判断した場合。': {
        en: '(2) If it is determined that the behavior of the Service User will interfere with our business.',
      },
      '(3) アカウントを複数取得した(禁止行為)場合。': {
        en: '(3) When multiple accounts are acquired (prohibited acts).',
      },
      '(4) 本件規約に違反し、またはそのおそれがある場合': {
        en: '(4) Violation of the Terms or the possibility of such violation.',
      },
      '(5) 前各号の他、利用制限措置を講じる必要があると当社が判断した場合': {
        en: '(5) In addition to the preceding items, when the Company determines that it is necessary to take usage restriction measures.',
      },
      '2 当社が第１項に基づき利用制限措置を講じたことにより、サービス利用者に損害が発生した場': {
        en: '2. Even if the Service User suffers damages as a result of the Company taking usage restriction measures based on paragraph 1, the Company shall not be liable for such damages.',
      },
      '合であっても、当社は当該損害について一切責任を負いません。': {
        en: ' ',
      },
      '3 本条に基づきサービス利用契約が解約される場合、サービス利用者は当社に負っている債務に': {
        en: '3. If the Service use contract is terminated based on this article, the Service User loses the benefit of time on the debts owed to the Company and must immediately perform all debts to the Company.',
      },
      'ついて期限の利益を喪失し、ただちに当社に対してすべての債務を履行しなければなりません。': {
        en: ' ',
      },
      '第18条（免責）': {
        en: 'Article 18 (Disclaimer)',
      },
      '1 本件規約に特段の定めがない限り、当社は、サービス利用者に発生した損害を賠償せず、サー': {
        en: '1. Unless otherwise stipulated in the Terms, the Company shall not compensate for damages incurred by the Service User, and the Service User may not claim against the Company for such damage. In addition, if the Service User causes damage to a third-party due to the use or termination of the Service, the user shall resolve this at his or her responsibility, and the Company shall not be held responsible. However, this does not apply if the damage was caused intentionally or by gross negligence on our part.',
      },
      'ビス利用者は当社に当該損害についての請求はできません。また、サービス利用者は、本件サー': {
        en: ' ',
      },
      'ビスの利用や利用の終了等により第三者に対し損害を与えた場合、自己の責任でこれを解決し、': {
        en: ' ',
      },
      '当社は責任を負担しません。ただし、当該損害が当社の故意または重過失によって生じた場合に': {
        en: ' ',
      },
      'はこの限りではありません。': {
        en: ' ',
      },
      '2 当社は、天災地変、戦争、暴動、内乱、延焼による火災、洪水、法令の改廃制定、停電、公権': {
        en: '2. The Company shall not be liable for natural disasters, wars, riots, civil strife, fires caused by the spread of fire, floods, revisions or abolitions of laws and regulations, power outages, intervention by public authorities, strikes, or other labor disputes, transportation accidents, the spread of infectious diseases, or declarations of a state of emergency. We will not be liable for damages or any other liability for non-fulfillment of obligations under the Service usage contract due to other reasons not attributable to our Company.',
      },
      '力の介入、ストライキその他の労働争議、輸送機関の事故、感染症の蔓延、緊急事態宣言の発令': {
        en: ' ',
      },
      'その他当社の責に帰すべからざる事由より生じたサービス利用契約上の義務の不履行について、': {
        en: ' ',
      },
      '損害賠償責任その他一切の責任を負いません。': {
        en: ' ',
      },
      '第19条（サービス利用者への通知）': {
        en: 'Article 19 (Notice to Service User)',
      },
      'サービス利用者は、当社からサービス利用者への通知が以下のいずれかの方法にて行われること': {
        en: 'The Service User agrees that the notice from the Company to the Service User will be made by one of the following methods.',
      },
      'に同意します。': {
        en: ' ',
      },
      '(1) 本件サービス内に掲載して行います。この場合は、掲載された時をもってサービス利用者に': {
        en: '(1) It will be posted in the Service. In this case, the notice to the Service User is considered completed at the time it is posted.',
      },
      '対する通知が完了したものとみなします。': {
        en: ' ',
      },
      '(2) 当社のWebサイト上に掲載して行います。この場合は、掲載された時をもってサービス利用': {
        en: '(2) Posting on our website. In this case, the notice to the Service User is considered completed at the time it is posted.',
      },
      '者に対する通知が完了したものとみなします。': {
        en: ' ',
      },
      '(3) サービス利用者が利用申込みの際またはその後に当社に届け出たサービス利用者の電子メー': {
        en: '(3) We will send an e-mail to the e-mail address of the Service User notified to us at the time of application for use or afterward. In this case, the notice to the Service User is deemed to have been completed when an e-mail is sent to the e-mail address of the Service User.',
      },
      'ルアドレス宛に電子メールを送信して行います。この場合は、サービス利用者の電子メールアド': {
        en: ' ',
      },
      レス宛に電子メールを送信した時をもってサービス利用者に対する通知が完了したものとみなし: {
        en: ' ',
      },
      'ます。': {
        en: ' ',
      },
      '(4) その他、当社が適切と判断する方法で行います。この場合は、当該通知の中で当社が指定し': {
        en: '(4) We will use other methods that we deem appropriate. In this case, the notice to the Service User shall be deemed to have been completed at the time specified by the Company in the notice.',
      },
      'た時をもってサービス利用者に対する通知が完了したものとみなします。': {
        en: ' ',
      },
      '第20条（反社会的勢力の排除）': {
        en: 'Article 20 (Exclusion of Antisocial Forces)',
      },
      'サービス利用者は、次の各号について表明し、保証します。': {
        en: 'The Service User represents and warrants the following items.',
      },
      '(1) 過去または将来において、自らが反社会的勢力（暴力団、暴力団員、暴力団準構成員、暴力': {
        en: '(1) In the past or in the future, oneself is an anti-social force (including organized crime groups, gang members, associate members of organized crime groups, companies related to organized crime groups, and corporate racketeers under the guise of social movements under the guise of political activities, or gangs with special intelligence, etc. The same shall apply, does not deal with anti-social forces, does not cooperate with or participate in the maintenance and management of anti-social forces through acts such as providing funds, and other anti-social forces.',
      },
      '団関係企業、総会屋、社会運動等標ぼうゴロ、政治活動標ぼうゴロまたは特殊知能暴力集団等を': {
        en: ' ',
      },
      '含む。以下同じ。）ではないこと、反社会的勢力と取引きを行っていないこと、資金提供等の行': {
        en: ' ',
      },
      '為を通じて反社会的勢力の維持、運営に協力もしくは関与していないこと、その他反社会的勢力': {
        en: ' ',
      },
      との意図的な交流がないこと: {
        en: ' ',
      },
      '(2) 自らまたは第三者を利用して、当社または当社の従業員に対して、暴行・傷害・脅迫・恐喝': {
        en: '(2) Violent or threatening acts such as assault, injury, threats, intimidation, intimidation, etc., or fraudulent acts such as dissemination of rumors or fraudulent means against the Company or its employees by themselves or by using a third-party; do not make requests using methods, unreasonable requests that exceed the reasonable range, obstruct business, damage honor, and credibility, etc.',
      },
      '・威圧等の暴力的もしくは脅迫的行為または風説の流布や偽計等の詐欺的手法を用いた要求、合': {
        en: ' ',
      },
      '理的な範囲を超える不当な要求、業務の妨害、名誉・信用の毀損等をおこなわないこと': {
        en: ' ',
      },
      '(3) 自らが、反社会的勢力であること、または反社会的勢力と関係がある旨を、当社または第三': {
        en: '(3) Do not act to inform the Company or a third-party that you are an anti-social force or have a relationship with an anti-social force.',
      },
      者に伝える等の行為をしないこと: {
        en: ' ',
      },
      '第21条（サービス利用契約上の地位の移転等）': {
        en: 'Article 21 (Transfer of Status under Service Use Contract, etc.)',
      },
      '1 サービス利用者は、サービス利用契約上の地位またはサービス利用契約に関して有する権利も': {
        en: '1. The Service User cannot transfer, succeed, sell, change the name of, or set collateral, etc… to a third-party regarding the status of the Service use contract or the rights or obligations held in relation to the Service use contract.',
      },
      'しくは義務について、第三者に譲渡、承継、売買、名義変更、担保設定等をすることはできませ': {
        en: ' ',
      },
      'ん。': {
        en: ' ',
      },
      '2 事業譲渡、会社分割、合併等の方法を問わず、当社が第三者に対して本件サービスにかかる事': {
        en: '2. Regardless of the method of business transfer, Company split, merger, etc., if the Company transfers or succeeds the business related to the Service to a third-party (referred to as "business transfer, etc."). Along with the business transfer, etc., the Company shall transfer the status under the Service use contract, the rights and obligations based on the Service use contract, and the authority to handle account information to the transferee of the business transfer, etc… without obtaining the separate consent of the Service User.',
      },
      '業の譲渡または承継（以下「事業譲渡等」といいます。）をする場合には、当社は当該事業譲渡': {
        en: ' ',
      },
      '等に伴い、サービス利用契約上の地位、サービス利用契約に基づく権利及び義務並びにアカウン': {
        en: ' ',
      },
      'ト情報を取り扱う権限を、サービス利用者の別段の同意を得ることなく当該事業譲渡等の譲受人': {
        en: ' ',
      },
      'に譲渡または承継することができるものとします。': {
        en: ' ',
      },
      '第22条（義務の存続）': {
        en: 'Article 22 (Sustainability of Obligations)',
      },
      'サービス利用契約が終了した場合であっても、サービス利用者は、サービス利用契約の終了前に': {
        en: 'Even if the Service Agreement is terminated, the Service User shall not be relieved of the obligations incurred prior to the termination of the Service Agreement.',
      },
      '発生した義務を免れません。': {
        en: ' ',
      },
      '第23条（本件件規約の変更）': {
        en: 'Article 23 (Changes to the Terms and Conditions)',
      },
      '1 当社は、以下の各号の場合には、サービス利用者の事前の承諾を得ることなく、本件規約を変': {
        en: '1. In the following cases, the Company shall be able to change the Terms without obtaining the prior consent of the Service User. In this case, the Company will notify the Service User of the changed Terms of Service in advance.',
      },
      '更できるものとします。この場合、当社は、事前に変更後の利用規約をサービス利用者に通知し': {
        en: ' ',
      },
      '(1) 本件規約の変更内容がサービス利用者の一般の利益に適合する場合': {
        en: '(1) When the content of the changes to the Terms conforms to the general interests of the Service User.',
      },
      '(2) 本件利用規約の変更がサービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内': {
        en: '(2) If the modification of the Terms of Use does not contravene the purpose of the Service User Agreement, and is reasonable in light of the necessity of modification, the appropriateness of the content after modification, and other circumstances related to the modification.',
      },
      '容の相当性、その他変更にかかる事情に照らして合理的である場合': {
        en: ' ',
      },
      '2 当社は、前項に定める他、サービス利用者から本件利用規約の変更について同意を得ることに': {
        en: '2. In addition to the provisions of the preceding paragraph, the Company may change the Terms of Use by obtaining the consent of the Service User to change the Terms of Use.',
      },
      'より、本件利用規約を変更できるものとします。': {
        en: ' ',
      },
      '3 以下の各号の場合には、サービス利用者は、本件利用規約の変更に同意したものとみなします。': {
        en: '3. In each of the following cases, the Service User shall be deemed to have agreed to the modification of the Terms of Use.',
      },
      '(1) 当社が変更の１ヶ月以上前にサービス利用者に対して本件利用規約の変更案及び本件利用規': {
        en: '(1) The Company shall notify the Service User of the proposed amendment to the Terms of Use and the date of amendment of the Terms of Use more than one month before the change, and the Service User shall notify the Company of the proposed amendment of the Terms of Use by the date of amendment of the Terms of Use. If there is no manifestation of objection to the change of the Terms of Use in writing, the modification will still take place according to the correct procedure.',
      },
      '約の変更日を通知し、本件利用規約の変更日までにサービス利用者から当社に対し、書面により': {
        en: ' ',
      },
      本件利用規約の変更に対する反対の意思表示がなされなかった場合: {
        en: ' ',
      },
      '(2) 当社がサービス利用者に対して本件利用規約の変更案及び本件利用規約の変更日を通知し、': {
        en: '(2) When the Company notifies the Service User of the proposed revision of the Terms of Use and the date of revision of the Terms of Use, and the Service User uses the Service after the said revision date.',
      },
      かつサービス利用者が当該変更日以降に本件サービスを利用した場合: {
        en: ' ',
      },
      '第24条（裁判管轄）': {
        en: 'Article 24 (Jurisdiction)',
      },
      '本件規約またはサービス利用契約に関するサービス利用者と当社との間の訴訟については、': {
        en: 'The Saitama District Court shall be the exclusive jurisdictional court of the first instance for litigation between the Service User and the Company regarding the Terms or the Service Use Agreement.',
      },
      'さいたま地方裁判所を第一審の専属的合意管轄裁判所とします。': {
        en: ' ',
      },
      '2021年11月10日 制定': {
        en: 'Established November 10, 2021',
      },
      '2022年3月22日 一部改定': {
        en: 'March 22, 2022 Partial revision',
      },
    },
  }),
  methods: {
    t(code) {
      if (this.i18n_mode === 'jp') {
        return code;
      }
      if (this.i18n_message[code]) {
        if (this.i18n_message[code][this.i18n_mode]) {
          return this.i18n_message[code][this.i18n_mode];
        }
      }

      if (this.i18n_mode !== 'jp') {
        console.log(`紐づけなし:${code}`);
      }
      return code;
    },
  },
};
